import { useQuery } from '@tanstack/react-query';
import exportService from 'v2/services/export';

export default function useGetAllowedEmailsExport() {
  const { data, isLoading } = useQuery<string[]>(['emailsExport'], () => exportService.getListEmailsAllowedToExport());
  return { isLoading, data: data || [] };
}
